module.exports = __webpack_public_path__ + "img/sam-rodriguez-untitled.d0ff3f6.jpg";